import { Yield } from '../../abacus/interfaces/yield.interface'

export const licenseYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
